WiseMetering.Collection.Groups = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Group,
    url: '/groups'
});
